/**
 * Coup de pouce — Attendu 1100 « prendre la fraction d'un nombre revient à
 * multiplier la fraction par ce nombre » (automatisme 4e, l. 657). UNE page
 * STATIQUE pour la série flash et le Vrai/Faux ; PAS de fiche sur le QCM
 * « Quel calcul ? » (pur rappel de l'écriture, doctrine règle 9 : après
 * l'aide il ne resterait qu'à reconnaître la réponse).
 *
 * L'image que l'élève a déjà : la barre de 1055 (5e, « le 1/3 de 18 ») et
 * le rituel de 1014 (6e, « les 2/3 de 12 »). Une barre de 12 coupée en 3
 * parts égales de 4, deux parts en orange ; le résultat en gros « les 2/3 de
 * 12 = 2/3 × 12 = 8 » ; deux lignes en langue d'élève : « 12 partagé en 3 :
 * une part fait 4. Deux parts : 8. » et « Prendre les 2/3 de 12, c'est
 * multiplier 2/3 par 12. » (la ligne du programme).
 *
 * SACRIFIÉS : (2/3 ; 12) sous ses trois écritures et (1/3 ; 18) importé de
 * 1055 (gen_1100, SACRIFIES, auto-testé par gen1100.self.test.js).
 * Largeur bornée à 340 px, tailles de 1048, fractions empilées.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const VERT = '#15803D';
const GRIS = '#E2E8F0';
const ENCRE = '#1E293B';

const XB = 40;
const WB = 320;
const NB = 3;
const WM = WB / NB;

/** Une fraction empilée, une couleur. */
const frac = (x, y, n, d, couleur, taille, demi) => `
  <text x="${x}" y="${y - 4}" font-size="${taille}" font-weight="bold" text-anchor="middle" fill="${couleur}">${n}</text>
  <line x1="${x - demi}" y1="${y}" x2="${x + demi}" y2="${y}" stroke="${couleur}" stroke-width="1.8"/>
  <text x="${x}" y="${y + taille + 1}" font-size="${taille}" font-weight="bold" text-anchor="middle" fill="${couleur}">${d}</text>`;

/** Les 3 parts de 4 : les deux premières en orange (prises), la troisième vide. */
const PARTS = Array.from({ length: NB }, (_, k) => {
    const x = XB + k * WM;
    const prise = k < 2;
    return `<rect x="${x}" y="96" width="${WM}" height="36" fill="${prise ? ORANGE_CLAIR : '#FFFFFF'}" stroke="${prise ? ORANGE : '#94A3B8'}" stroke-width="${prise ? 2 : 1.2}"/>
  <text x="${x + WM / 2}" y="${120}" font-size="14" font-weight="bold" text-anchor="middle" fill="${prise ? ORANGE : '#94A3B8'}">4</text>`;
}).join('\n  ');

const SVG_PARTS = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 268" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="Les 2 tiers de 12, c'est combien ? Une barre entière de 12, et dessous la même longueur coupée en 3 parts égales de 4 ; les deux premières parts sont en orange. Les 2 tiers de 12 égale 2 tiers fois 12 égale 8. 12 partagé en 3 : une part fait 4. Deux parts : 8. Prendre les 2 tiers de 12, c'est multiplier 2 tiers par 12.">
  <text x="168" y="32" font-size="16" font-weight="bold" text-anchor="end" fill="${ENCRE}">les</text>
  ${frac(184, 26, 2, 3, ORANGE, 12, 9)}
  <text x="200" y="32" font-size="16" font-weight="bold" fill="${ENCRE}">de <tspan fill="${VERT}">12</tspan> = ?</text>
  <rect x="${XB}" y="48" width="${WB}" height="36" fill="${GRIS}" stroke="${ENCRE}" stroke-width="1.5"/>
  <text x="200" y="73" font-size="15" font-weight="bold" text-anchor="middle" fill="${VERT}">12</text>
  ${PARTS}

  <!-- le résultat : les 2/3 de 12 = 2/3 × 12 = 8 -->
  <text x="112" y="180" font-size="17" font-weight="bold" text-anchor="end" fill="${ENCRE}">les</text>
  ${frac(128, 173, 2, 3, ORANGE, 14, 11)}
  <text x="144" y="180" font-size="17" font-weight="bold" fill="${ENCRE}">de <tspan fill="${VERT}">12</tspan> =</text>
  ${frac(224, 173, 2, 3, ORANGE, 14, 11)}
  <text x="240" y="180" font-size="17" font-weight="bold" fill="${ENCRE}">× <tspan fill="${VERT}">12</tspan> = <tspan fill="${ORANGE}">8</tspan></text>

  <!-- le geste, puis la ligne du programme -->
  <text x="200" y="222" font-size="12" text-anchor="middle" fill="${ENCRE}"><tspan font-weight="bold" fill="${VERT}">12</tspan> partagé en <tspan font-weight="bold" fill="${BLEU}">3</tspan> : une part fait 4. Deux parts : <tspan font-weight="bold" fill="${ORANGE}">8</tspan>.</text>
  <text x="140" y="250" font-size="12" text-anchor="end" fill="${ENCRE}">Prendre les</text>
  ${frac(154, 245, 2, 3, ORANGE, 10, 7)}
  <text x="168" y="250" font-size="12" fill="${ENCRE}">de 12, c'est multiplier</text>
  ${frac(310, 245, 2, 3, ORANGE, 10, 7)}
  <text x="324" y="250" font-size="12" fill="${ENCRE}">par 12.</text>
</svg>`.trim();

const AIDE = { pages: [{ titre: 'Les 2/3 de 12', svg: SVG_PARTS }] };

const CP_1100 = {
    flash_texte_trou_saisie: AIDE,
    sens_tableau_vf: AIDE,
    // calcul_qcm_unique : pas de fiche (pur rappel de l'écriture, règle 9)
};

export default CP_1100;
